import { Button } from '@mint-lib/tw-components';

import { Separator } from './Separator.jsx';

type MainButtonProps = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  color?: 'primary' | 'ai';
  separator?: boolean;
  ariaLabel?: string;
  dataDdActionName?: string;
};

export function MainButton({
  label,
  onClick,
  icon,
  color,
  disabled,
  separator,
  ariaLabel,
  dataDdActionName,
}: Readonly<MainButtonProps>) {
  return (
    <>
      <Button
        aria-label={ariaLabel}
        data-dd-action-name={dataDdActionName}
        color={color ?? 'primary'}
        variant="contained"
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
        {label}
      </Button>
      {separator && <Separator />}
    </>
  );
}
